import { Add } from '@mui/icons-material';
import { Fab, FabProps } from '@mui/material';
import { ReactElement, useState } from 'react';
import styles from './CollapsibleFab.module.scss';
import classNames from 'classnames';

export interface CollapsibleFabButtonItem extends FabProps {
    text?: string;
    icon?: ReactElement;
}

type CollapsibleFabProps = {
    buttons: CollapsibleFabButtonItem[];
};

export const CollapsibleFab = ({ buttons }: CollapsibleFabProps) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!buttons || !buttons?.length) {
        return null;
    }

    return (
        <div data-testid="collapsible-fab" className={styles.container}>
            <Fab
                onClick={() => setIsOpen(!isOpen)}
                size="medium"
                color={isOpen ? 'error' : 'primary'}
                className={classNames(styles.primaryFab, {
                    [styles.isOpen]: isOpen,
                })}
            >
                <Add />
            </Fab>
            {buttons.map((btn, index) => (
                <Fab
                    {...btn}
                    key={`fab-button-${index}`}
                    data-testid={btn.id}
                    onClick={(e) => {
                        btn.onClick && btn.onClick(e);
                        setIsOpen(false);
                    }}
                    className={classNames(styles.expandedButton, {
                        [styles.isOpen]: isOpen,
                    })}
                    color={btn.color ?? 'info'}
                    size="small"
                    sx={{
                        transform: `scale(${isOpen ? 1 : 0}) translateY(-${
                            (index + 1) *
                                (index === 0 ? 60 : 45) *
                                (isOpen ? 1 : 0) +
                            (index !== 0 ? 15 : 0)
                        }px)`,
                    }}
                    disabled={!isOpen}
                    variant={btn.text ? 'extended' : 'circular'}
                >
                    {btn.icon && btn.icon} {btn.text && btn.text}
                </Fab>
            ))}
        </div>
    );
};
